module.exports = __webpack_public_path__ + "img/27.86b6eb80.png";